export default __webpack_public_path__ + "static/vBTC-a2fde635a91e2fd25be93ebadfe717cc.png";